import { Body1, ColorClass, Header3 } from "ui";
import styles from "./css/CameraDetail.module.css";

export function CameraDetail({
  labelAndValue,
  omitLabel = false,
}: {
  labelAndValue: { label: string; value: any };
  omitLabel?: boolean;
}) {
  return (
    <div className={styles.cameraDetail}>
      {!omitLabel && (
        <Header3 colorClass={ColorClass.Primary} textTransform="uppercase">
          {labelAndValue.label}
        </Header3>
      )}
      <Body1 colorClass={ColorClass.Primary}>{labelAndValue.value}</Body1>
    </div>
  );
}
